import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import React, { ReactNode } from 'react';
import Btn from './Btn';
import EllipsisText from './EllipsisText';

type Props = {
  /**
   * React children, usually text.
   */
  children: ReactNode;
}

const DocumentButton: React.FunctionComponent<Props> = (props): JSX.Element => {
  const { children } = props;

  return (
    <Btn>
      <FontAwesomeIcon icon={['fal', 'file-alt']} />
      <EllipsisText
        widthLarge={'200px'}
        forceSingleLine={true}
      >
        {children}
      </EllipsisText>
    </Btn>
  );
};

export default DocumentButton;
